export default "__VITE_ASSET__D8XuDt4w__"